const state = {
  ASSETS_PREFIX: process.env.VUE_APP_ASSETS_PREFIX,
  ALGOLIA_APPLICATION_ID: process.env.VUE_APP_ALGOLIA_APPLICATION_ID,
  ALGOLIA_SEARCH_API_KEY: process.env.VUE_APP_ALGOLIA_SEARCH_API_KEY,
};

const getters = {};

const actions = {};

const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
